import React from 'react';
import { ChevronRight } from 'lucide-react';
import { DASH_COLORS, money } from './DashCard';

const Bar = ({ label, value, max, color, testid }) => (
  <div className="flex items-center gap-2">
    <span className="w-10 text-xs text-slate-500 dark:text-slate-400 shrink-0">{label}</span>
    <div className="flex-1 h-2.5 rounded-full bg-slate-200/70 dark:bg-slate-800 overflow-hidden">
      <div className="h-full rounded-full" style={{ width: `${max ? Math.max(2, (Math.max(value, 0) / max) * 100) : 0}%`, background: color }} />
    </div>
    <span className={`w-[88px] text-right font-mono text-sm shrink-0 ${value < 0 ? 'text-rose-600' : 'text-slate-900 dark:text-white'}`} data-testid={testid}>{money(value)}</span>
  </div>
);

/** Mobile-friendly per-unit comparison: every unit visible with labelled gross/net amounts, no tapping needed. */
export const UnitBarsList = ({ data = [], onSelect }) => {
  const max = Math.max(0, ...data.map((d) => d.gross || 0));
  const rows = data;
  return (
    <ul className="divide-y divide-slate-200/70 dark:divide-slate-800" data-testid="unit-bars-list">
      {rows.map((d) => (
        <li key={d.id || d.name}>
          <button type="button" onClick={() => onSelect?.(d.id)} className="w-full text-left py-3 space-y-1.5 rounded-lg px-1 -mx-1 active:bg-blue-50 dark:active:bg-slate-800 hover:bg-blue-50/60 dark:hover:bg-slate-800/60 transition-colors" data-testid={`unit-bars-${d.name}`}>
            <div className="flex items-center justify-between text-sm font-semibold text-slate-900 dark:text-white">
              <span>Unit {d.name}{d.driver ? <span className="font-normal text-slate-500 dark:text-slate-400"> · {d.driver}</span> : null}</span>
              {onSelect && <ChevronRight className="h-4 w-4 text-slate-400" />}
            </div>
            <Bar label="Gross" value={d.gross || 0} max={max} color={DASH_COLORS.gross} testid={`unit-bars-gross-${d.name}`} />
            <Bar label="Net" value={d.net || 0} max={max} color={DASH_COLORS.fees} testid={`unit-bars-net-${d.name}`} />
          </button>
        </li>
      ))}
    </ul>
  );
};
